




















import Vue from 'vue'
import { mapGetters } from 'vuex'
import { Content, Icon } from '@neurotrack/web-shared-components'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default Vue.extend({
  name: 'FAQs',
  components: { Content, Icon },
  props: {
    category: String
  },
  computed: {
    ...mapGetters('content/faqs', ['faqs']),

    categoryTitle(): string {
      return this.faqs(this.category)[0]?.fields?.category?.fields?.name || ''
    }
  },
  data() {
    return {
      active: -1
    }
  },
  created() {
    if (!this.faqs(this.category).length) {
      this.$store.dispatch('content/faqs/loadFromContentful')
    }
  },
  methods: {
    documentToHtmlString,
    toggleActive(index: number) {
      if (index === this.active) {
        this.active = -1
      } else {
        this.active = index
      }
    }
  }
})
